import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ChaingeChain,
  ChaingeContracts,
  ChaingeTokenChain,
} from "types/baseType";
import { formatWagmiChains } from "utils";
import request from "utils/request";
import { Chain } from "viem";

// 获取链列表
export const getSupportChains = createAsyncThunk("app/getChains", async () => {
  const { code = -1, data = {} }: any = await request.get("/getChain");
  if (code === 0) {
    const wagmiChains: Chain[] = [];
    let chainList = data.list;
    // delisted 下架  disabled 暂时禁用
    // 过滤下架的链
    chainList = chainList.filter(
      (item: ChaingeChain) => !(item.delisted || item.disabled)
    );

    const disabledChain = [
      "HT",
      "OKC",
      "ETC",
      "FTM",
      "KLAY",
      "ETHW",
      "ETHF",
      "CAD",
      "METIS",
      "CIC",
      "FSK",
      "CRO",
      "ELA",
      "CFXEVM",
      "FEVM",
      "TELOSEVM",
      "FUSE",
      "TARA",
      "RSK",
      "CANTO",
    ];
    chainList = chainList.filter(
      (item: ChaingeChain) => !disabledChain.includes(item.nickName)
    );

    const availableChain = [
      "FSN",
      "ETH",
      "BNB",
      "AVAXC",
      "POLYGON",
      "AURORA",
      "CORE",
      "SYSEVM",
      "ARB",
      "OP",
      "BASE",
      "LINEA",
      "ZKEVM",
      "ZKSYNC",
      "OPBNB",
      "ROLLUX",
      "SCROLL",
      "SHIBA",
      'MERLIN'
    ];
    chainList = chainList.filter((item: ChaingeChain) =>
      availableChain.includes(item.nickName)
    );

    chainList.forEach((item: ChaingeChain) => {
      const wagmiChainItem: Chain = formatWagmiChains(item);
      wagmiChains.push(wagmiChainItem);
    });

    return {
      chains: chainList,
      wagmiChains,
    };
  }
  return "";
});

// 获取资产列表
export const getSupportAssets = createAsyncThunk("app/getAssets", async () => {
  const { code = -1, data = {} }: any = await request.get("/getAssets");
  if (code === 0) {
    let tokenList = data.list as ChaingeTokenChain[];
    // 添加下架过滤
    tokenList = tokenList.filter((item) => !item.delisted);

    let newTokenList = tokenList.map((item: ChaingeTokenChain) => {
      const contractObj = item.contracts;

      const chainNameKey = Object.keys(contractObj);
      const availableContracts: { [key: string]: ChaingeContracts } = {};
      chainNameKey.forEach((item) => {
        if (!contractObj[item].delisted) {
          availableContracts[item] = contractObj[item];
        }
      });
      const availableChains = Object.keys(availableContracts);

      item["chainList"] = availableChains;
      item["contracts"] = availableContracts;
      return item;
    });

    // const availAbleToken = [
    //   "FSN",
    //   "XCHNG",
    //   "BTC",
    //   "ETH",
    //   "USDT",
    //   "USDC",
    //   "DAI",
    //   "BNB",
    //   "TRX",
    //   "LINK",
    //   "MATIC",
    //   "OP",
    //   "ARB",
    //   "SOL",
    //   "ETC",
    //   "ADA",
    //   "APT",
    //   "KAS",
    //   "AVAX",
    //   "ATOM",
    //   "UNI",
    //   "INJ",
    //   "NEAR",
    //   "DOGE",
    //   "DOT",
    //   "SUSHI",
    //   "ALGO",
    //   "EGLD",
    //   "XRP",
    //   "CRO",
    //   "AZERO",
    //   "CMP",
    //   "CANTO",
    //   "CFX",
    //   "CIC",
    //   "CORE",
    //   "CUBE",
    //   "ELA",
    //   "ETHF",
    //   "ETHW",
    //   "FIL",
    //   "FTM",
    //   "FUSE",
    //   "HT",
    //   "KLAY",
    //   "KOIN",
    //   "KSM",
    //   "METIS",
    //   "NEXA",
    //   "OKT",
    //   "SYS",
    //   "RBTC",
    //   "SUI",
    //   "TARA",
    //   "TLOS",
    //   "LUNA",
    //   "LUNC",
    //   "XLM",
    //   "CHINESE",
    //   "FREE",
    //   "FMN",
    //   "PEOPLE",
    //   "WEMIX",
    //   "KLEVA",
    //   "BORA",
    //   "KSP",
    //   "KFI",
    //   "MOMAT",
    //   "LC",
    //   "PQC",
    //   "RNFT",
    //   "LOVE",
    //   "SEXY",
    //   "TRADE",
    //   "MEX",
    //   "BHAT",
    //   "RIDE",
    //   "ITHEUM",
    //   "ZPAY",
    //   "ALCAZAR",
    //   "WOW",
    //   "SFC",
    //   "SHIB",
    //   "CTT",
    //   "STB",
    //   "BUSD",
    //   "BHC",
    //   "MANA",
    //   "APE",
    //   "LDO",
    //   "TON",
    //   "LTC",
    //   "BCH",
    //   "OKB",
    //   "IMX",
    //   "VET",
    //   "MNT",
    //   "RNDR",
    //   "GRT",
    //   "AAVE",
    //   "QNT",
    //   "FLOW",
    //   "MKR",
    //   "FTT",
    //   "SNX",
    //   "SAND",
    //   "BTT",
    //   "AXS",
    //   "KCS",
    //   "XTZ",
    //   "EOS",
    //   "GALA",
    //   "WOO",
    //   "CAKE",
    //   "FXS",
    //   "STC",
    //   "SATS",
    //   "HOICHI",
    //   "BONE",
    //   "ROSX",
    //   "RIO",
    //   "IZI",
    //   "RYIU",
    //   "FI"
    // ];

    // newTokenList = newTokenList.filter((item) => {
    //   return availAbleToken.includes(item.symbol);
    // });

    // const disabledChainList = ['FSN']
    // const availableTokenByDisabledChain = ['ROSX']
    // newTokenList = newTokenList.map((item) => {
    //   if(!availableTokenByDisabledChain.includes(item.symbol)) {
    //     let tempSupportChainList = [...(item.chainList || [])]
    //     tempSupportChainList = tempSupportChainList.filter((supItem) => !disabledChainList.includes(supItem))

    //     item.chainList = tempSupportChainList

    //     disabledChainList.forEach((disabledChain) => {
    //       delete item.contracts[disabledChain]
    //     });
    //   }
    //   return item
    // })

    return newTokenList;
  }
  return "";
});

export const getGasUsdList = createAsyncThunk(
  "app/getChainGasUsd",
  async () => {
    const { code = -1, data = {} }: any = await request.get("/getChainGasUsd");
    if (code === 0) {
      return data;
    }
    return [];
  }
);
